<template><section><template>
<h3>Toast</h3>
<div class="bs-docs-section" id="Toast">
<div class="bs-example">
  <n3-button @click.native="showToast">Click</n3-button>
<div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showToast"</span>&gt;</span>Click<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    showToast () {
      <span class="hljs-keyword">this</span>.n3Toast({
        <span class="hljs-attr">text</span>: <span class="hljs-string">'success'</span>,
        <span class="hljs-attr">type</span>: <span class="hljs-string">'success'</span>,
        <span class="hljs-attr">placement</span>: <span class="hljs-string">'top'</span>,
        <span class="hljs-attr">closeOnClick</span> : <span class="hljs-literal">true</span>
      })
    }
  }
}
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>text</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>text to show on toast</td>
</tr>
<tr>
<td>placement</td>
<td><code v-pre="">String</code>  one of  <code v-pre="">top</code>, <code v-pre="">top-right</code>,<code v-pre="">top-left</code>, <code v-pre="">bottom</code>,<code v-pre="">bottom-left</code>, <code v-pre="">bottom-right</code></td>
<td><code v-pre="">center</code>.</td>
<td>placement</td>
</tr>
<tr>
<td>type</td>
<td><code v-pre="">String</code> one of  <code v-pre="">default</code>, <code v-pre="">primary</code>, <code v-pre="">success</code>, <code v-pre="">info</code>, <code v-pre="">warning</code>, <code v-pre="">danger</code></td>
<td><code v-pre="">default</code></td>
<td>color</td>
</tr>
<tr>
<td>duration</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">3000</code></td>
<td>duration setting ,you can set it as <code v-pre="">0</code> to prevent Alert to be closed</td>
</tr>
<tr>
<td>closeOnClick</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>it will hide when click</td>
</tr>
</tbody>
</table>
</div>
</div></div></template>

</section></template>

<script>
export default {
  methods: {
    showToast () {
      this.n3Toast({
        text: 'success',
        type: 'success',
        placement: 'top',
        closeOnClick : true
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3ToastDocs.md?07ea4754